export default {"container":"_8Ej50","card":"kIKrq","image":"_8hyMN","content":"U0o-k","description":"vvb2A","loading":"qmPgH"};